import React from 'react';
import PropTypes from 'prop-types';
import { customHtml, i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import config from 'src/js/modules/config';

const { Popover, PopoverTrigger, PopoverContent } = designSystem;
const { renderStatuses } = customHtml.constants;

const CustomHtmlRenderOption = ({ value, label }) => {
  const isRuntimeOption = value === renderStatuses.RUNTIME;
  const guideUrl = config.accessors.getCustomHtmlInstructionUrl();

  const optionContent = <div>{label}</div>;
  const description = i18next.t(
    'For advanced use. Executes code in real time. Learn more about <a href="{learnMoreUrl}" target="_blank">running custom code in Editor</a>',
    { learnMoreUrl: guideUrl }
  );

  if (!isRuntimeOption) {
    return optionContent;
  }

  return (
    <Popover
      width={250}
      placement="left-center"
      appearance="dark"
      description={
        <span
          /* eslint-disable-next-line yola/react/no-danger */
          dangerouslySetInnerHTML={{ __html: description }}
        />
      }
      customOffset={20}
    >
      <PopoverTrigger>{optionContent}</PopoverTrigger>
      <PopoverContent />
    </Popover>
  );
};

CustomHtmlRenderOption.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default CustomHtmlRenderOption;
